import React from 'react'
import { reactular } from '@vendhq/reactular'
import { useT } from '@transifex/react'
import { TextAreaInput } from '@lightspeed/design-system-react'
import DOMPurify from 'dompurify'

interface Props {
  registerClosureNote?: string
  editable?: Readonly<boolean>
  onNoteUpdate?: (newNote: string) => void
}

export const RegisterClosureSummaryNotes: React.FC<Props> = ({
  registerClosureNote = '',
  editable = false,
  onNoteUpdate,
}) => {
  const t = useT()
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const sanitizedValue = DOMPurify.sanitize(event.target.value)

    if (onNoteUpdate) {
      onNoteUpdate(sanitizedValue)
    }
  }

  return (
    <div className="vd-field">
      <div className="vd-label">Note</div>
      <div className="vd-value">
        {editable ? (
          <TextAreaInput
            className="vd-mb5"
            name="note"
            value={registerClosureNote}
            onChange={handleChange}
            placeholder={t('Type to add a register closure note', {
              _context: 'Placeholder',
            })}
            rows={2}
          />
        ) : (
          registerClosureNote && (
            <div className="wr-register-closure-notes wr-honour-line-breaks">
              <p className="wr-info-field-value vd-p">{registerClosureNote}</p>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export const RegisterClosureSummaryNotesComponent = reactular<Props>(
  RegisterClosureSummaryNotes,
  ['registerClosureNote', 'editable', 'onNoteUpdate']
)
